module.exports = __webpack_public_path__ + "img/HistoryAnomalyDetection.4024b98e.png";